var View = require('views/base/view');
var BlocksView = require('views/block/block-collection-view');
var ContentService = require('services/content-service');

var FeedbackView = View.extend({
  autoRender: true,
  autoAttach: true,
  region: 'feedback',
  noWrap: true,
  template: require('views/feedback/templates/feedback'),
  initialize: function(options){
    this.model.set('cid', this.model.cid);
    if (this.model.get('class')){
      this.className += this.model.get('class');
    }
    this.callbacks = options.callbacks;
    this.script = options.script;
    var self = this;
    let role = this.model.get('role');
    if (!this.model.get('aria-hidden')){
      if (role === null || role === undefined){
        self.$el.attr('role', 'alert');
      } else if (role !== false){
        self.$el.attr('role', role)
      }
    }
    this.on('addedToDOM', function() {
      var blocksRegion = this.model.get('cid') + '_feedback_blocks';
      this.registerRegion(blocksRegion, '.' + blocksRegion);
      ContentService.buildBlockCollection(this.model.get('blocks')).then((blocks) => {
        this.blocks = blocks;
        var blocksView = new BlocksView({
          script: this.script ? this.script.block : undefined,
          collection: this.blocks,
          region: blocksRegion,
          parent: this
        });

        self.subview('blocks', blocksView);
        self.listenTo(blocksView, 'block:state:completed', self.blockCompleted);
        self.setState('loaded');
        // if there is a 'close' button, move focus on it when feedback is added to dom - accessibility issue
        if (self.$('[data-close]')) {
          self.$('[data-close]').trigger('focus');
        }
        self.delegate('click', '[data-close]', function (e) {
          e.preventDefault();
          self.trigger('feedback:close', this);
        });
      });
    });

    this.setState('initialized');
    View.prototype.initialize.apply(this, arguments);
  },
  play: function(){
    this.setState('playing');
    if (this.blocks && this.blocks.length === 0){
      this.setState('completed');
    }
  },
  blockCompleted: function() {
    if (this.subviewsByName.blocks.isComplete()){
      this.setState('completed');
    }
  },
  stateCallbacks: {
    unloading: function(){
      this.setState('unloaded');
      View.prototype.dispose.apply(this, arguments);
    },
    completed: function() {
      if(this.model && this.model.get('closeOnComplete')) {
        this.trigger('feedback:close', this);
      }
    }
  },
  setState: function(state){
    //console.log('page state: ' + state);
    this.model.set('state', state);
    //feedback is kinda like a mini page - needs to talk to blocks the same way
    Chaplin.mediator.publish('feedback:state:' + this.model.get('state'), this);

    var hook = this.script && this.script[state] ? _.bind(this.script[state], this.script) : null;
    var stateCallback = this.stateCallbacks[state] ? _.bind(this.stateCallbacks[state], this) : null;
    var callback = this.callbacks && this.callbacks[state] ? _.bind(this.callbacks[state], this) : null;

    var callCallbacks = function(){
      if (callback){
        callback();
      }
      if (stateCallback){
        stateCallback();
      }
    };

    if (hook){
      if (this.script[state].length === 2){
        hook(this, callCallbacks);
      } else {
        hook(this);
        callCallbacks();
      }
    } else {
      callCallbacks();
    }
    this.trigger('page:state:change', this);
  },
  dispose: function(){
    this.setState('unloading');
  }
});

module.exports = FeedbackView;
